var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled, { css } from 'styled-components';
import { fromSize } from '../../utilities/media';
export var El = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var styleName = _a.styleName;
  return getStyleName(styleName);
});
var getStyleName = function (x) {
  switch (x) {
    case 'editorialTitle1':
      return editorialTitle1;
    case 'editorialTitle2':
      return editorialTitle2;
    case 'title1':
      return title1;
    case 'title2':
      return title2;
    case 'title3':
      return title3;
    case 'title4':
      return title4;
    case 'title5':
      return title5;
    case 'title6':
      return title6;
    case 'title7':
      return title7;
    case 'title8':
      return title8;
    case 'bodyLarge':
      return bodyLarge;
    case 'bodyRegular':
      return bodyRegular;
    case 'bodySmall':
      return bodySmall;
    case 'label':
      return label;
    case 'labelSmall':
      return labelSmall;
  }
};
// --- Text Variants
var variantTitleInverted = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'inverted' ? css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.text.title.reversed) : '';
});
var variantTitleSecondary = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'secondary' ? css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.text.title.light) : '';
});
var variantBodyInverted = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'inverted' ? css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.text.paragraph.reversed) : '';
});
var variantSecondary = css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'secondary' ? css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.text.paragraph.light) : '';
});
var variantTertiary = css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'tertiary' ? css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.text.paragraph.lighter) : '';
});
var variantLink = css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'link' ? css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n          color: ", ";\n          font-weight: ", ";\n          text-decoration: underline;\n          cursor: pointer;\n        "], ["\n          color: ", ";\n          font-weight: ", ";\n          text-decoration: underline;\n          cursor: pointer;\n        "])), theme.tokens.accent.base.primary.regular, theme.typography.font.weight.semibold) : '';
});
var variantPositive = css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'positive' ? css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.text.label.positive) : '';
});
var variantNegative = css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'negative' ? css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.text.label.negative) : '';
});
var variantWarning = css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'warning' ? css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.text.label.warning) : '';
});
var variantInfo = css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'info' ? css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.text.label.info) : '';
});
var variantLinkSecondary = css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'linkSecondary' ? css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n          color: ", ";\n          font-weight: ", ";\n        "], ["\n          color: ", ";\n          font-weight: ", ";\n        "])), theme.tokens.accent.base.primary.regular, theme.typography.font.weight.semibold) : '';
});
var variantTip = css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'tip' ? css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.interface.feedback.tip.strong) : '';
});
var variantFeatPrimary = css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'feat-primary' ? css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.feature.primary.strong) : '';
});
var variantFeatPrimaryInverted = css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'feat-primary-inverted' ? css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.text.paragraph.reversed) : '';
});
var variantFeatSecondary = css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'feat-secondary' ? css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.feature.secondary.strong) : '';
});
var variantFeatSecondaryInverted = css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"
// --- Text Styles
])), function (_a) {
  var variant = _a.variant,
    theme = _a.theme;
  return variant === 'feat-secondary-inverted' ? css(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.tokens.text.paragraph.reversed) : '';
});
var editorialTitle1 = css(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n  font-size: 52px;\n  line-height: 1.125;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  ", " {\n    font-size: 64px;\n  }\n  ", "\n  ", "\n"], ["\n  font-size: 52px;\n  line-height: 1.125;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  ", " {\n    font-size: 64px;\n  }\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.title.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.title;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, fromSize('lg'), variantTitleInverted, variantTitleSecondary);
var editorialTitle2 = css(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n  font-size: 48px;\n  line-height: 1.125;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 52px;\n  }\n\n  ", "\n  ", "\n"], ["\n  font-size: 48px;\n  line-height: 1.125;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 52px;\n  }\n\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.title.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.title;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, fromSize('lg'), variantTitleInverted, variantTitleSecondary);
var title1 = css(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n  font-size: 38px;\n  line-height: 1.125;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 48px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: 38px;\n  line-height: 1.125;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 48px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.title;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, fromSize('lg'), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.title.regular;
}, variantTitleInverted, variantTitleSecondary);
var title2 = css(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n  font-size: 32px;\n  line-height: 1.25;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 38px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: 32px;\n  line-height: 1.25;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 38px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.title;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, fromSize('lg'), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.title.regular;
}, variantTitleInverted, variantTitleSecondary);
var title3 = css(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n  font-size: 28px;\n  line-height: 1.25;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 32px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: 28px;\n  line-height: 1.25;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 32px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.title;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, fromSize('lg'), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.title.regular;
}, variantTitleInverted, variantTitleSecondary);
var title4 = css(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n  font-size: 24px;\n  line-height: 1.25;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 28px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: 24px;\n  line-height: 1.25;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 28px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.title;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, fromSize('lg'), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.title.regular;
}, variantTitleInverted, variantTitleSecondary);
var title5 = css(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n  font-size: 22px;\n  line-height: 1.25;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 24px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: 22px;\n  line-height: 1.25;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 24px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.title;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, fromSize('lg'), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.title.regular;
}, variantTitleInverted, variantTitleSecondary);
var title6 = css(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n  font-size: 20px;\n  line-height: 1.25;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 22px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: 20px;\n  line-height: 1.25;\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", " {\n    font-size: 22px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.title;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, fromSize('lg'), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.title.regular;
}, variantTitleInverted, variantTitleSecondary);
var title7 = css(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n  font-size: 18px;\n  line-height: 1.25;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: 18px;\n  line-height: 1.25;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.title.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.title;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, variantTitleInverted, variantTitleSecondary);
var title8 = css(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 1.25;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: 16px;\n  line-height: 1.25;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.title.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.title;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, variantTitleInverted, variantTitleSecondary);
var bodyLarge = css(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n  font-size: 18px;\n  line-height: 1.5;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  & strong {\n    font-weight: ", ";\n  }\n  letter-spacing: 0.2px;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  font-size: 18px;\n  line-height: 1.5;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  & strong {\n    font-weight: ", ";\n  }\n  letter-spacing: 0.2px;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.paragraph.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.text;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.normal;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, variantBodyInverted, variantSecondary, variantTertiary, variantLink, variantPositive, variantNegative, variantWarning, variantInfo, variantTip);
var bodyRegular = css(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 1.5;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  & strong {\n    font-weight: ", ";\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  font-size: 16px;\n  line-height: 1.5;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  & strong {\n    font-weight: ", ";\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.paragraph.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.text;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.normal;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, variantBodyInverted, variantSecondary, variantTertiary, variantLink, variantPositive, variantNegative, variantWarning, variantInfo, variantTip);
var bodySmall = css(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 1.5;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  & strong {\n    font-weight: ", ";\n  }\n  letter-spacing: 0.2px;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  font-size: 14px;\n  line-height: 1.5;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  & strong {\n    font-weight: ", ";\n  }\n  letter-spacing: 0.2px;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.paragraph.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.text;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.normal;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, variantBodyInverted, variantSecondary, variantTertiary, variantLink, variantPositive, variantNegative, variantWarning, variantInfo, variantLinkSecondary, variantTip);
var label = css(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 1.5;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  font-size: 16px;\n  line-height: 1.5;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.label.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.text;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, variantBodyInverted, variantSecondary, variantTertiary, variantPositive, variantNegative, variantTip, variantWarning);
var labelSmall = css(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 1.5;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  font-size: 14px;\n  line-height: 1.5;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.label.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.text;
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.weight.semibold;
}, variantBodyInverted, variantSecondary, variantTertiary, variantPositive, variantNegative, variantTip, variantWarning, variantFeatPrimary, variantFeatPrimaryInverted, variantFeatSecondary, variantFeatSecondaryInverted);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48;